import React from 'react';
import {
	Navbar,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	InputGroup,
	Input,
	InputGroupText,
} from 'reactstrap';
import Logo from '../assets/img/Logo.jpg';
import Logo2 from '../assets/img/new-med-icon.png';
const Header = () => {
	return (
		<>
			<Navbar light className='ml-0 ml-md-5'>
				<NavbarBrand href='/'>
					<img
						src={Logo}
						alt='logo'
						className='logo d-none d-md-flex'
					/>
					<img
						src={Logo2}
						alt='logo'
						className='logo d-flex d-md-none'
					/>
				</NavbarBrand>
				<InputGroup className='header__search ml-5'>
					<Input placeholder='Search for Products' />
					<InputGroupText>
						<i className='fa fa-search px-2'></i>
					</InputGroupText>
				</InputGroup>
				<Nav className='ml-auto d-none d-md-flex font-sub-paragraph'>
					<NavItem>
						<NavLink>
							Favorate{' '}
							<i className='fa fa-chevron-down font-xsmall'></i>
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink>
							English{' '}
							<i className='fa fa-chevron-down font-xsmall'></i>
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink>
							USD{' '}
							<i className='fa fa-chevron-down font-xsmall'></i>
						</NavLink>
					</NavItem>
					<NavItem className='border-left mx-2'></NavItem>
					<NavItem>
						<NavLink href='/login'>
							<i className='fa fa-user font-sub-title'></i>
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href='/shoppingcart'>
							<i className='fa fa-shopping-cart font-sub-title'></i>
						</NavLink>
					</NavItem>
				</Nav>
			</Navbar>
		</>
	);
};

export default Header;
